'use strict';

var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Card = require('../../../DesignSystem/Surfaces/Cards/Card.js');
var CardContent = require('../../../DesignSystem/Surfaces/Cards/CardContent.js');
var CardActions = require('../../../DesignSystem/Surfaces/Cards/CardActions.js');
var withStyles = require('../../../DesignSystem/Styles/withStyles.js');
var Button = require('../../../DesignSystem/Inputs/Buttons/Button/Button.js');
var Grid = require('../../../DesignSystem/Layout/Grid/Grid.js');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
require('prop-types');
var Chip = require('../../../DesignSystem/DataDisplay/Chip/Chip.js');
var ObjectHelper = require('../../../common/ObjectHelper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var getButtonName = "GET";

var styles = function styles(theme) {
  return {
    appCardWidth: {
      width: 290
    },
    appCardContainer: {
      position: 'relative',
      height: 320
    },
    tagLabel: {
      padding: '10px 20px',
      position: 'absolute',
      left: -5,
      top: 20,
      zIndex: 2,
      transition: 'transform .3s cubic-bezier(0.25, 0.1, 0.25, 1), -webkit-transform .3s cubic-bezier(0.25, 0.1, 0.25, 1)',
      '&::before': {
        background: '#4683e9',
        content: '""',
        bottom: 0,
        left: 0,
        position: 'absolute',
        right: 5,
        top: 0,
        zIndex: -1
      },
      '&::after': {
        background: '#4683e9',
        content: '""',
        bottom: 0,
        position: 'absolute',
        right: 5,
        webkitTransformOrigin: 'right bottom',
        transformOrigin: 'right bottom',
        webkitTransform: 'skew(-20deg)',
        transform: 'skew(-20deg)',
        top: 0,
        width: 30,
        zIndex: -1
      }
    },
    statusContainer: {
      textAlign: 'right',
      height: 56
    },
    iconContainer: {
      height: 96,
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& > img': {
        maxWidth: '95%',
        maxHeight: '95%'
      }
    },
    appDescriptionContainer: {
      height: 56
    }
  };
};

var AppCard = function AppCard(_ref) {
  var classes = _ref.classes,
      tag = _ref.tag,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? false : _ref$status,
      icon = _ref.icon,
      appName = _ref.appName,
      appDescription = _ref.appDescription,
      learnMoreURL = _ref.learnMoreURL;
      _ref.openAppURL;
      var _onClick = _ref.onClick,
      _ref$learnMoreButtonN = _ref.learnMoreButtonName,
      learnMoreButtonName = _ref$learnMoreButtonN === void 0 ? "Learn more" : _ref$learnMoreButtonN,
      _ref$showGetButton = _ref.showGetButton,
      showGetButton = _ref$showGetButton === void 0 ? true : _ref$showGetButton,
      _ref$disableTypograph = _ref.disableTypography,
      disableTypography = _ref$disableTypograph === void 0 ? false : _ref$disableTypograph,
      actions = _ref.actions,
      restOfProps = objectWithoutProperties(_ref, ["classes", "tag", "status", "icon", "appName", "appDescription", "learnMoreURL", "openAppURL", "onClick", "learnMoreButtonName", "showGetButton", "disableTypography", "actions"]);

  var onGetButtonClick = function onGetButtonClick() {
    if (ObjectHelper.isPresent(_onClick)) {
      _onClick(getButtonName.toLowerCase());
    }

    if (ObjectHelper.isPresent(learnMoreURL)) {
      window.location.href = learnMoreURL;
    }
  };

  var DisplayGetButton = function DisplayGetButton(_ref2) {
    var status = _ref2.status;
    return status ? React__default["default"].createElement(Chip, {
      label: 'ACTIVE',
      color: "primary"
    }) : React__default["default"].createElement(Chip, {
      label: getButtonName,
      onClick: onGetButtonClick
    });
  };

  var cardActions = actions;

  if (!cardActions && learnMoreButtonName) {
    cardActions = React__default["default"].createElement(CardActions, null, React__default["default"].createElement(Button["default"], {
      size: "small",
      color: "primary",
      href: learnMoreURL,
      onClick: function onClick() {
        return _onClick(learnMoreButtonName.toLowerCase());
      }
    }, learnMoreButtonName));
  }

  return React__default["default"].createElement("div", {
    className: classes.appCardWidth
  }, React__default["default"].createElement(Card, restOfProps, React__default["default"].createElement("div", {
    className: classes.appCardContainer
  }, tag && React__default["default"].createElement("div", {
    className: classes.tagLabel
  }, React__default["default"].createElement(Typography, {
    variant: "body1",
    style: {
      color: '#fff'
    }
  }, tag)), React__default["default"].createElement(CardContent, null, React__default["default"].createElement(Grid, {
    container: true,
    spacing: 8,
    alignItems: 'center'
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.statusContainer
  }, showGetButton && React__default["default"].createElement(DisplayGetButton, {
    status: status
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.iconContainer
  }, icon), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, disableTypography ? appName : React__default["default"].createElement(Typography, {
    variant: "h6"
  }, appName)), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.appDescriptionContainer
  }, disableTypography ? appDescription : React__default["default"].createElement(Typography, {
    variant: "body2"
  }, appDescription)))), cardActions)));
};

var AppCard$1 = withStyles["default"](styles)(AppCard);

module.exports = AppCard$1;
